/**
 * 個別施術ページ用の「初めての方限定モニター専用LP」への導線。
 *
 * 医療脱毛の施術ページ（HairRemovalMonitorLink）と完全に同じ位置・構造・デザインで表示するための
 * 汎用コンポーネント。PRICEセクション内の「料金表を見る」の直後に配置して使用する。
 *
 * 【SBDCの価格掲載ルール】
 *   公式サイト ＝ 定価のみを掲載する。
 *   LPサイト   ＝ 新規お試しモニター価格を掲載する。
 * したがって、このブロックにはモニター価格・割引率・通常価格との比較・キャンペーン価格などの
 * 価格訴求を一切掲載しない。あくまでLPへの入口のみを設置する。
 *
 * 外部LPへの遷移は別タブ（target="_blank" rel="noopener noreferrer"）で行い、
 * 既存の医療脱毛LP導線と挙動を統一する。
 */
type FirstVisitMonitorLinkProps = {
  /** 小見出し（既定：FOR FIRST VISIT） */
  eyebrow?: string;
  /** ブロック見出し */
  title: string;
  /** 説明文 */
  description: string;
  /** ボタンラベル */
  label: string;
  /** 遷移先（外部LP） */
  url: string;
};

export default function FirstVisitMonitorLink({
  eyebrow = "FOR FIRST VISIT",
  title,
  description,
  label,
  url,
}: FirstVisitMonitorLinkProps) {
  return (
    <div className="flex flex-col gap-7 border border-accent-300 bg-accent-50/70 p-8 md:flex-row md:items-center md:justify-between md:p-10">
      <div>
        <span className="en-eyebrow text-[10px] text-accent-700 md:text-[11px]">{eyebrow}</span>
        <p className="mt-4 max-w-2xl font-heading text-[16px] leading-[1.9] text-foreground-900 md:text-lg">
          {title}
        </p>
        <p className="mt-3 max-w-2xl text-[12.5px] leading-[2] text-foreground-600">{description}</p>
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-flex shrink-0 items-center justify-center gap-3 whitespace-nowrap rounded-md bg-primary-600 px-8 py-3.5 text-[14px] font-medium text-background-50 transition-colors hover:bg-primary-700"
      >
        {label}
        <i className="ri-external-link-line transition-transform group-hover:translate-x-0.5" aria-hidden />
      </a>
    </div>
  );
}